export const getRegioesHidrograficas = (state) => state.regioesHidrograficas.lista
export const getIsCarregandoListaRegioesHidrograficas =
  (state) => state.regioesHidrograficas.isCarregandoLista
export const getIsSavingRegioesHidrograficas = (state) => state.regioesHidrograficas.isSaving
export const getIsUpdatingRegioesHidrograficas = (state) => state.regioesHidrograficas.isUpdate
